(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["b2b-welcome-options"] && !Shopify.designMode) return;
  try {
    
  if (window.customElements && !customElements.get('b2b-wl-carousel')) {
    class B2bWlCarousel extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.track = this.querySelector('[data-track]');
        this.slides = this.track ? Array.prototype.slice.call(this.track.querySelectorAll('[data-slide]')) : [];
        if (this.slides.length < 2) return;
        this.ready = true;
        this.index = 0;
        this.locked = false;
        this.dots = Array.prototype.slice.call(this.querySelectorAll('[data-dot]'));
        this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        var prev = this.querySelector('[data-prev]');
        var next = this.querySelector('[data-next]');
        if (prev) prev.addEventListener('click', this.step.bind(this, -1, true));
        if (next) next.addEventListener('click', this.step.bind(this, 1, true));
        this.dots.forEach(function (dot, i) {
          dot.addEventListener('click', this.go.bind(this, i, true));
        }, this);

        this.addEventListener('keydown', function (event) {
          if (event.key === 'ArrowLeft') { event.preventDefault(); this.step(-1, true); }
          if (event.key === 'ArrowRight') { event.preventDefault(); this.step(1, true); }
        }.bind(this));

        var ticking = false;
        this.track.addEventListener('scroll', function () {
          if (ticking) return;
          ticking = true;
          window.requestAnimationFrame(function () {
            ticking = false;
            var width = this.track.clientWidth || 1;
            var at = Math.max(0, Math.min(this.slides.length - 1, Math.round(this.track.scrollLeft / width)));
            if (this.locked) {
              if (at === this.index) this.locked = false;
              return;
            }
            this.setIndex(at);
          }.bind(this));
        }.bind(this), { passive: true });

        if ('IntersectionObserver' in window) {
          this.loader = new IntersectionObserver(function (entries) {
            if (!entries[entries.length - 1].isIntersecting) return;
            this.slides.forEach(function (slide) {
              var image = slide.querySelector('img');
              if (image) image.loading = 'eager';
            });
            this.loader.disconnect();
          }.bind(this), { rootMargin: '200px' });
          this.loader.observe(this);
        }

        this.setUpAutoplay();
        this.classList.add('is-ready');
        this.setIndex(0);
      }

      disconnectedCallback() {
        this.stop();
        if (this.observer) this.observer.disconnect();
        if (this.loader) this.loader.disconnect();
      }

      setIndex(i) {
        this.index = i;
        this.dots.forEach(function (dot, n) {
          if (n === i) dot.setAttribute('aria-current', 'true'); else dot.removeAttribute('aria-current');
        });
      }

      step(dir, byUser) {
        this.go((this.index + dir + this.slides.length) % this.slides.length, byUser);
      }

      go(i, byUser) {
        if (byUser) this.stopForGood();
        this.locked = true;
        window.clearTimeout(this.lockTimer);
        this.lockTimer = window.setTimeout(function () { this.locked = false; }.bind(this), 700);
        this.setIndex(i);
        this.track.scrollTo({ left: i * this.track.clientWidth, behavior: this.reduceMotion ? 'auto' : 'smooth' });
      }

      setUpAutoplay() {
        var delay = parseInt(this.getAttribute('data-autoplay'), 10);
        if (!delay || this.reduceMotion || (window.Shopify && window.Shopify.designMode)) return;
        this.delay = Math.max(delay, 2000);
        this.inView = false;
        this.paused = false;
        var pause = function () { this.paused = true; this.stop(); }.bind(this);
        var resume = function () { this.paused = false; this.start(); }.bind(this);
        this.addEventListener('mouseenter', pause);
        this.addEventListener('mouseleave', resume);
        this.addEventListener('focusin', pause);
        this.addEventListener('focusout', resume);
        this.track.addEventListener('touchstart', this.stopForGood.bind(this), { passive: true });
        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(function (entries) {
            this.inView = entries[entries.length - 1].isIntersecting;
            if (this.inView) this.start(); else this.stop();
          }.bind(this), { threshold: 0.5 });
          this.observer.observe(this);
        } else {
          this.inView = true;
          this.start();
        }
      }

      start() {
        if (!this.delay || this.timer || this.paused || !this.inView) return;
        this.timer = window.setInterval(this.step.bind(this, 1, false), this.delay);
      }

      stop() {
        window.clearInterval(this.timer);
        this.timer = null;
      }

      stopForGood() {
        this.stop();
        this.delay = 0;
      }
    }
    customElements.define('b2b-wl-carousel', B2bWlCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));

      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));

      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));

      this.onHideDropdown = this.closeSelector.bind(this);
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
      document.body.removeEventListener('click', this.onHideDropdown);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());

      document.body.addEventListener('click', this.onHideDropdown);
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (shouldClose) {
        this.hidePanel();
      }
      let eventTarget = event.target;
      if (!eventTarget.closest('.dropdown__open_label')) {
        this.hidePanel();
      }

    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kc-backbar-formats"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';
  function sync(id) {
    Array.prototype.forEach.call(document.querySelectorAll('[data-kcp-format]'), function (el) {
      el.classList.toggle('is-on', String(el.getAttribute('data-kcp-format')) === String(id));
    });
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target.closest('[data-kcp-choose]') : null;
    if (!t) return;
    document.dispatchEvent(new CustomEvent('kcpdp:select', { detail: { variantId: t.getAttribute('data-kcp-choose'), scroll: true } }));
  });
  document.addEventListener('kcpdp:variant', function (e) { if (e.detail) sync(e.detail.id); });
  function boot() { if (window.KCPDP && window.KCPDP.current) sync(window.KCPDP.current.id); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kc-backbar-label-guide"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';
  function init(root) {
    if (root.kcpReady) return;
    root.kcpReady = true;
    var pins = root.querySelectorAll('[data-kcp-pin]');
    var cards = root.querySelectorAll('[data-kcp-pin-card]');
    function set(i) {
      Array.prototype.forEach.call(pins, function (el, k) {
        el.classList.toggle('is-on', k === i);
        el.setAttribute('aria-pressed', k === i ? 'true' : 'false');
      });
      Array.prototype.forEach.call(cards, function (el, k) { el.classList.toggle('is-on', k === i); });
    }
    root.kcpSet = set;
    Array.prototype.forEach.call(pins, function (el, k) {
      el.addEventListener('click', function () { set(k); });
      el.addEventListener('mouseenter', function () { set(k); });
      el.addEventListener('focus', function () { set(k); });
    });
    Array.prototype.forEach.call(cards, function (el, k) {
      el.addEventListener('click', function () { set(k); });
      el.addEventListener('mouseenter', function () { set(k); });
    });
  }
  function boot() { Array.prototype.forEach.call(document.querySelectorAll('[data-kcp-guide]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('shopify:block:select', function (e) {
    var card = e.target.closest ? e.target.closest('[data-kcp-pin-card]') : null;
    var root = card ? card.closest('[data-kcp-guide]') : null;
    if (root && root.kcpSet) root.kcpSet(parseInt(card.getAttribute('data-kcp-pin-card'), 10));
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kc-backbar-session-cost"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';
  var FMT = new RegExp('\\{\\{\\s*(\\w+)\\s*\\}\\}');
  function group(n, dec, th, ds) {
    var p = n.toFixed(dec).split('.');
    p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, th);
    return p.join(ds);
  }
  function money(cents, fmt, whole) {
    var v = cents / 100, m = FMT.exec(fmt || ''), out;
    switch (m ? m[1] : 'amount') {
      case 'amount_no_decimals': out = group(v, 0, ',', '.'); break;
      case 'amount_with_comma_separator': out = group(v, whole ? 0 : 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': out = group(v, 0, '.', ','); break;
      default: out = group(v, whole ? 0 : 2, ',', '.');
    }
    return m ? fmt.replace(FMT, out) : '$' + out;
  }

  function init(root) {
    if (root.kcpReady) return;
    root.kcpReady = true;
    var fmt = root.getAttribute('data-money-format') || '';
    var sess = root.querySelector('[data-kcp-in-sess]');
    var ml = root.querySelector('[data-kcp-in-ml]');
    var sizes = Array.prototype.slice.call(root.querySelectorAll('[data-kcp-size]'));
    var addBtn = root.querySelector('[data-kcp-cost-add]');
    var cur = root.querySelector('[data-kcp-size].is-on') || sizes[0];
    function text(sel, value) { var el = root.querySelector(sel); if (el) el.textContent = value; }

    function calc() {
      var s = parseInt(sess.value, 10) || 1, m = parseFloat(ml.value) || 1;
      var vol = parseFloat(cur.getAttribute('data-volume')) || 0;
      var price = cur.hasAttribute('data-price') ? parseInt(cur.getAttribute('data-price'), 10) : null;
      var per = Math.max(1, Math.round(vol / m)), weeks = per / s;
      text('[data-kcp-out-sess]', s);
      text('[data-kcp-out-ml]', m + ' mL');
      text('[data-kcp-sessions]', per);
      text('[data-kcp-weeks]', weeks >= 1 ? weeks.toFixed(1) : '<1');
      sizes.forEach(function (b) {
        var on = b === cur;
        b.classList.toggle('is-on', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      if (price === null) return;
      var cps = price / per;
      text('[data-kcp-cps]', money(Math.round(cps), fmt));
      text('[data-kcp-monthly]', money(Math.round(cps * s * 4.33 / 100) * 100, fmt, true));
      if (addBtn) {
        addBtn.textContent = root.getAttribute('data-add-prefix') + ' ' + cur.getAttribute('data-name') + ' · ' + money(price, fmt);
        addBtn.disabled = cur.hasAttribute('data-unavailable');
      }
    }

    sess.addEventListener('input', calc);
    ml.addEventListener('input', calc);
    sizes.forEach(function (b) {
      b.addEventListener('click', function () {
        cur = b;
        calc();
        document.dispatchEvent(new CustomEvent('kcpdp:select', { detail: { variantId: b.getAttribute('data-kcp-size'), scroll: false, keepImage: true } }));
      });
    });
    if (addBtn) addBtn.addEventListener('click', function () {
      var id = cur.getAttribute('data-kcp-size');
      if (document.querySelector('[data-kcp-buybox]')) {
        document.dispatchEvent(new CustomEvent('kcpdp:select', { detail: { variantId: id, scroll: false, keepImage: true } }));
        document.dispatchEvent(new CustomEvent('kcpdp:add', { detail: { variantId: id, quantity: 1 } }));
      } else {
        window.location.href = (root.getAttribute('data-cart-add') || '/cart/add') + '?id=' + encodeURIComponent(id) + '&quantity=1';
      }
    });
    root.kcpSync = function (id) {
      sizes.forEach(function (b) { if (String(b.getAttribute('data-kcp-size')) === String(id)) cur = b; });
      calc();
    };
    if (window.KCPDP && window.KCPDP.current) root.kcpSync(window.KCPDP.current.id); else calc();
  }

  document.addEventListener('kcpdp:variant', function (e) {
    if (!e.detail) return;
    Array.prototype.forEach.call(document.querySelectorAll('[data-kcp-cost]'), function (root) { if (root.kcpSync) root.kcpSync(e.detail.id); });
  });
  function boot() { Array.prototype.forEach.call(document.querySelectorAll('[data-kcp-cost]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kc-backbar-session-story"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';
  function init(root) {
    if (root.kcpReady) return;
    root.kcpReady = true;
    var slides = root.querySelectorAll('[data-kcp-story-slide]');
    var steps = root.querySelectorAll('[data-kcp-story-step]');
    var dots = root.querySelectorAll('[data-kcp-story-dot]');
    var cap = root.querySelector('[data-kcp-story-cap]');
    var current = -1;
    function set(i) {
      if (i === current) return;
      current = i;
      var caption = '';
      Array.prototype.forEach.call(slides, function (el) {
        var on = parseInt(el.getAttribute('data-kcp-story-slide'), 10) === i;
        el.classList.toggle('is-on', on);
        if (on) caption = el.getAttribute('data-caption') || '';
      });
      Array.prototype.forEach.call(steps, function (el, k) { el.classList.toggle('is-on', k === i); });
      Array.prototype.forEach.call(dots, function (el, k) { el.classList.toggle('is-on', k === i); });
      if (cap) { cap.textContent = caption; cap.hidden = !caption; }
    }
    Array.prototype.forEach.call(steps, function (el, k) {
      el.addEventListener('click', function (e) { if (!e.target.closest('a, button')) set(k); });
    });
    if ('IntersectionObserver' in window) {
      root.kcpObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) set(parseInt(en.target.getAttribute('data-kcp-story-step'), 10));
        });
      }, { rootMargin: '-45% 0px -45% 0px' });
      Array.prototype.forEach.call(steps, function (el) { root.kcpObserver.observe(el); });
    }
    set(0);
  }
  function boot() { Array.prototype.forEach.call(document.querySelectorAll('[data-kcp-story]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('shopify:block:select', function (e) {
    var step = e.target.closest ? e.target.closest('[data-kcp-story-step]') : null;
    if (step) step.click();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kc-pdp-buy-box"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';
  var FMT = new RegExp('\\{\\{\\s*(\\w+)\\s*\\}\\}');
  function group(n, dec, th, ds) {
    var p = n.toFixed(dec).split('.');
    p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, th);
    return p.join(ds);
  }
  function money(cents, fmt) {
    var v = cents / 100, m = FMT.exec(fmt || ''), out;
    switch (m ? m[1] : 'amount') {
      case 'amount_no_decimals': out = group(v, 0, ',', '.'); break;
      case 'amount_with_comma_separator': out = group(v, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': out = group(v, 0, '.', ','); break;
      default: out = group(v, 2, ',', '.');
    }
    return m ? fmt.replace(FMT, out) : '$' + out;
  }

  function init(root) {
    if (root.kcpReady) return;
    root.kcpReady = true;

    var portal = root.querySelector('[data-kcp-portal]');
    if (portal) document.body.appendChild(portal);
    root.kcpPortal = portal;
    function $(sel) { return root.querySelector(sel) || (portal && portal.querySelector(sel)); }
    function $$(sel) {
      var a = Array.prototype.slice.call(root.querySelectorAll(sel));
      return portal ? a.concat(Array.prototype.slice.call(portal.querySelectorAll(sel))) : a;
    }

    var data = {};
    try { data = JSON.parse(root.querySelector('[data-kcp-data]').textContent); } catch (e) { data = {}; }
    var fmt = data.moneyFormat || '';
    var options = $$('[data-kcp-option]');
    var form = $('[data-kcp-form]');
    var idInput = $('[data-kcp-id]');
    var qtyInput = $('[data-kcp-qty]');
    var planInput = $('[data-kcp-plan-input]');
    var auto = $('[data-kcp-auto]');
    var addBtn = $('[data-kcp-add]');
    var state = { option: null, qty: 1, auto: false, plan: null, planName: '', image: 0, busy: false };

    options.forEach(function (o) { if (o.classList.contains('is-on')) state.option = o; });
    if (!state.option) state.option = options[0] || null;
    var firstPlan = $('[data-kcp-plan].is-on') || $('[data-kcp-plan]');
    if (firstPlan) { state.plan = firstPlan.getAttribute('data-kcp-plan'); state.planName = firstPlan.getAttribute('data-plan-name'); }

    function info(o) {
      if (!o) return null;
      var price = o.hasAttribute('data-price') ? parseInt(o.getAttribute('data-price'), 10) : null;
      var id = o.getAttribute('data-variant-id');
      var units = parseInt(o.getAttribute('data-units'), 10) || 0;
      var planOn = state.auto && o.getAttribute('data-group') === 'primary';
      if (planOn && price !== null && data.plans && data.plans[id] && data.plans[id][state.plan] != null) price = data.plans[id][state.plan];
      return {
        id: id, group: o.getAttribute('data-group'), name: o.getAttribute('data-name'), units: units,
        volume: parseFloat(o.getAttribute('data-volume')) || 0, price: price, available: !o.disabled,
        unitPrice: price === null ? null : (units > 1 ? Math.round(price / units) : price), plan: planOn ? state.plan : null
      };
    }

    function showImage(i) {
      var thumbs = $$('[data-kcp-thumb]'), main = $('[data-kcp-main]'), t = null;
      thumbs.forEach(function (b) { if (parseInt(b.getAttribute('data-kcp-thumb'), 10) === i) t = b; });
      if (!t || !main) return;
      state.image = i;
      main.removeAttribute('srcset');
      main.src = t.getAttribute('data-src');
      if (t.getAttribute('data-srcset')) main.setAttribute('srcset', t.getAttribute('data-srcset'));
      main.alt = t.getAttribute('data-alt') || '';
      thumbs.forEach(function (b) { b.classList.toggle('is-on', b === t); });
      var cap = $('[data-kcp-cap]');
      if (cap) {
        var text = t.getAttribute('data-alt') || '';
        cap.textContent = text;
        cap.hidden = !text || text.length > 48;
      }
    }

    function render() {
      var cur = info(state.option);
      if (!cur) return;
      options.forEach(function (o) {
        var on = o === state.option;
        o.classList.toggle('is-on', on);
        o.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      if (idInput) idInput.value = cur.id;
      if (auto) {
        auto.hidden = cur.group !== 'primary';
        auto.classList.toggle('is-on', state.auto);
        var sw = $('[data-kcp-auto-switch]');
        if (sw) sw.setAttribute('aria-checked', state.auto ? 'true' : 'false');
        $$('[data-kcp-plan]').forEach(function (b) { b.classList.toggle('is-on', b.getAttribute('data-kcp-plan') === state.plan); });
      }
      if (planInput) {
        planInput.disabled = !cur.plan;
        planInput.value = cur.plan || '';
      }
      if (cur.price !== null) {
        var total = money(cur.price * state.qty, fmt);
        var label = state.qty + ' × ' + cur.name + (cur.plan && state.planName ? ' · ' + state.planName : '');
        var tl = $('[data-kcp-total-label]'); if (tl) tl.textContent = label;
        var tt = $('[data-kcp-total]'); if (tt) tt.textContent = total;
        $$('[data-kcp-bar-total]').forEach(function (e) { e.textContent = total; });
        $$('[data-kcp-bar-sel]').forEach(function (e) { e.textContent = cur.name + ' · qty ' + state.qty + (cur.plan ? ' · autoship' : ''); });
        $$('[data-kcp-bar-name]').forEach(function (e) { e.textContent = cur.name; });
        if (cur.units > 1) {
          $$('[data-kcp-fact="unit_price"]').forEach(function (e) { e.textContent = money(cur.unitPrice, fmt); });
          if (data.msrp) $$('[data-kcp-fact="margin"]').forEach(function (e) { e.textContent = money(data.msrp - cur.unitPrice, fmt); });
        }
        var pn = $('[data-kcp-packnote]');
        if (pn) {
          pn.hidden = !(cur.units > 1 && cur.group === 'primary');
          if (!pn.hidden) {
            $('[data-kcp-pn-name]').textContent = cur.name;
            $('[data-kcp-pn-value]').textContent = money(data.msrp * cur.units, fmt);
            $('[data-kcp-pn-keep]').textContent = money((data.msrp - cur.unitPrice) * cur.units, fmt);
          }
        }
      }
      if (addBtn && !state.busy) {
        addBtn.disabled = !cur.available;
        addBtn.textContent = cur.available ? root.getAttribute('data-add-label') : root.getAttribute('data-sold-out-label');
      }
      window.KCPDP = window.KCPDP || {};
      window.KCPDP.current = cur;
      document.dispatchEvent(new CustomEvent('kcpdp:variant', { detail: cur }));
    }

    function select(o, opts) {
      if (!o || o.disabled) return;
      opts = opts || {};
      state.option = o;
      var idx = parseInt(o.getAttribute('data-image-index'), 10);
      if (idx > -1 && !opts.keepImage) showImage(idx);
      if (o.getAttribute('data-group') === 'primary' && window.history && window.history.replaceState) {
        try {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', o.getAttribute('data-variant-id'));
          window.history.replaceState(window.history.state, '', url.toString());
        } catch (e) { state.urlLocked = true; }
      }
      render();
      if (opts.scroll) root.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
    function selectById(id, opts) {
      var hit = null;
      options.forEach(function (o) { if (String(o.getAttribute('data-variant-id')) === String(id)) hit = o; });
      if (hit) select(hit, opts);
      return hit;
    }

    var toastTimer;
    function toast(message) {
      var t = $('[data-kcp-toast]');
      if (!t) return;
      $('[data-kcp-toast-text]').textContent = message;
      t.classList.add('is-on');
      clearTimeout(toastTimer);
      toastTimer = setTimeout(function () { t.classList.remove('is-on'); }, 4000);
    }
    function flash() {
      var proxies = $$('[data-kcp-add-proxy]'), all = addBtn ? proxies.concat([addBtn]) : proxies;
      all.forEach(function (b) { b.classList.add('is-added'); b.textContent = root.getAttribute('data-added-label') + ' ✓'; });
      setTimeout(function () {
        all.forEach(function (b) { b.classList.remove('is-added'); b.textContent = root.getAttribute('data-add-label'); });
        render();
      }, 1500);
    }
    function showError(message) {
      var e = $('[data-kcp-error]');
      if (!e) return;
      e.textContent = message || '';
      e.hidden = !message;
    }

    function addToCart(item, label) {
      if (state.busy) return;
      state.busy = true;
      showError('');
      if (addBtn) addBtn.disabled = true;
      var body = { items: [item] };
      fetch((data.cartAddUrl || '/cart/add') + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(body)
      }).then(function (r) {
        return r.json().then(function (json) { if (!r.ok) throw new Error(json.description || json.message || ''); return json; });
      }).then(function (json) {
        state.busy = false;
        if (data.afterAdd === 'cart') { window.location.href = data.cartUrl || '/cart'; return; }
        flash();
        toast(label);
        try {
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: json }));
          document.dispatchEvent(new CustomEvent('cart:refresh', { detail: json }));
          if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'kc-pdp', cartData: json });
        } catch (e) { return; }
      }).catch(function (err) {
        state.busy = false;
        render();
        showError(err && err.message ? err.message : root.getAttribute('data-error-label'));
      });
    }
    function submit() {
      var cur = info(state.option);
      if (!cur || !cur.available) return;
      var item = { id: parseInt(cur.id, 10), quantity: state.qty };
      if (cur.plan) item.selling_plan = parseInt(cur.plan, 10);
      addToCart(item, state.qty + ' × ' + cur.name + ' added');
    }

    function setQty(n) {
      state.qty = Math.max(1, Math.min(99, n || 1));
      if (qtyInput) qtyInput.value = state.qty;
      render();
    }

    root.addEventListener('click', function (e) {
      var t = e.target.closest('button, a');
      if (!t || !root.contains(t)) return;
      if (t.hasAttribute('data-kcp-option')) { select(t); return; }
      if (t.hasAttribute('data-kcp-thumb')) { showImage(parseInt(t.getAttribute('data-kcp-thumb'), 10)); return; }
      if (t.hasAttribute('data-kcp-q')) { setQty(state.qty + parseInt(t.getAttribute('data-kcp-q'), 10)); return; }
      if (t.hasAttribute('data-kcp-auto-switch')) { state.auto = !state.auto; render(); return; }
      if (t.hasAttribute('data-kcp-plan')) { state.plan = t.getAttribute('data-kcp-plan'); state.planName = t.getAttribute('data-plan-name'); render(); return; }
      if (t.hasAttribute('data-kcp-zoom')) {
        var lb = $('[data-kcp-lightbox]'), main = $('[data-kcp-main]');
        if (lb && main) { $('[data-kcp-lightbox-img]').src = main.currentSrc || main.src; lb.classList.add('is-on'); $('[data-kcp-lightbox-close]').focus(); }
      }
    });
    if (qtyInput) qtyInput.addEventListener('change', function () { setQty(parseInt(qtyInput.value, 10)); });
    if (form) form.addEventListener('submit', function (e) { e.preventDefault(); submit(); });
    if (portal) portal.addEventListener('click', function (e) {
      var t = e.target.closest('button');
      if (t && t.hasAttribute('data-kcp-add-proxy')) { submit(); return; }
      var lb = portal.querySelector('[data-kcp-lightbox]');
      if (lb && ((t && t.hasAttribute('data-kcp-lightbox-close')) || e.target === lb)) { lb.classList.remove('is-on'); var z = $('[data-kcp-zoom]'); if (z) z.focus(); }
    });
    root.kcpKey = function (e) {
      if (e.key !== 'Escape' || !portal) return;
      var lb = portal.querySelector('[data-kcp-lightbox]');
      if (lb) lb.classList.remove('is-on');
    };
    document.addEventListener('keydown', root.kcpKey);

    var bars = $$('[data-kcp-sbar], [data-kcp-mbar]'), buy = $('[data-kcp-buy]');
    if (bars.length && buy && 'IntersectionObserver' in window) {
      root.kcpObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          var on = !en.isIntersecting && en.boundingClientRect.top < 0;
          bars.forEach(function (b) { b.classList.toggle('is-on', on); if (on) b.removeAttribute('inert'); else b.setAttribute('inert', ''); });
        });
      }, { threshold: 0 });
      root.kcpObserver.observe(buy);
    }

    root.kcpApi = { select: selectById, add: function (id, qty) {
      var o = null;
      options.forEach(function (x) { if (String(x.getAttribute('data-variant-id')) === String(id)) o = x; });
      var name = o ? o.getAttribute('data-name') : '';
      addToCart({ id: parseInt(id, 10), quantity: qty || 1 }, (qty || 1) + ' × ' + name + ' added');
    }, selectGroup: function (groupName, opts) {
      var hit = null;
      options.forEach(function (o) { if (!hit && !o.disabled && o.getAttribute('data-group') === groupName) hit = o; });
      if (hit) select(hit, opts);
      return hit;
    } };

    showImage(state.image = (function () { var on = $('[data-kcp-thumb].is-on'); return on ? parseInt(on.getAttribute('data-kcp-thumb'), 10) : 0; })());
    render();
  }

  function first() {
    var root = document.querySelector('[data-kcp-buybox]');
    return root && root.kcpApi ? root.kcpApi : null;
  }
  document.addEventListener('kcpdp:select', function (e) {
    var api = first(), d = e.detail || {};
    if (!api) return;
    if (d.variantId) api.select(d.variantId, { scroll: d.scroll !== false, keepImage: !!d.keepImage });
    else if (d.group) api.selectGroup(d.group, { scroll: d.scroll !== false });
  });
  document.addEventListener('kcpdp:add', function (e) {
    var api = first(), d = e.detail || {};
    if (api && d.variantId) api.add(d.variantId, d.quantity || 1);
  });

  function boot() { Array.prototype.forEach.call(document.querySelectorAll('[data-kcp-buybox]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('shopify:section:unload', function (e) {
    var root = e.target.querySelector('[data-kcp-buybox]');
    if (!root) return;
    if (root.kcpPortal && root.kcpPortal.parentNode) root.kcpPortal.parentNode.removeChild(root.kcpPortal);
    if (root.kcpObserver) root.kcpObserver.disconnect();
    if (root.kcpKey) document.removeEventListener('keydown', root.kcpKey);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kc-retail-math"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';
  var FMT = new RegExp('\\{\\{\\s*(\\w+)\\s*\\}\\}');
  function group(n, dec, th, ds) {
    var p = n.toFixed(dec).split('.');
    p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, th);
    return p.join(ds);
  }
  function money(cents, fmt, whole) {
    var v = cents / 100, m = FMT.exec(fmt || ''), out;
    switch (m ? m[1] : 'amount') {
      case 'amount_no_decimals': out = group(v, 0, ',', '.'); break;
      case 'amount_with_comma_separator': out = group(v, whole ? 0 : 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': out = group(v, 0, '.', ','); break;
      default: out = group(v, whole ? 0 : 2, ',', '.');
    }
    return m ? fmt.replace(FMT, out) : '$' + out;
  }

  function init(root) {
    if (root.kcpReady) return;
    root.kcpReady = true;
    var fmt = root.getAttribute('data-money-format') || '';
    var noun = root.getAttribute('data-noun'), nouns = root.getAttribute('data-noun-plural');
    var roller = root.getAttribute('data-bottle') === 'roller';
    var packs = Array.prototype.slice.call(root.querySelectorAll('[data-kcp-math-pack]'));
    var retailIn = root.querySelector('[data-kcp-in-retail]');
    var weeklyIn = root.querySelector('[data-kcp-in-weekly]');
    var rack = root.querySelector('[data-kcp-rack]');
    var addBtn = root.querySelector('[data-kcp-math-add]');
    var cur = root.querySelector('[data-kcp-math-pack].is-on') || packs[0];
    function text(sel, value) { var el = root.querySelector(sel); if (el) el.textContent = value; }
    function bottle(cls) {
      return '<div class="kcp-btl' + (roller ? ' kcp-btl--roller' : '') + (cls ? ' ' + cls : '') + '"><span class="kcp-btl__cap"></span><span class="kcp-btl__neck"></span><div class="kcp-btl__body"><span class="kcp-btl__band"></span></div></div>';
    }

    function calc() {
      var n = parseInt(cur.getAttribute('data-units'), 10) || 0;
      var price = cur.hasAttribute('data-price') ? parseInt(cur.getAttribute('data-price'), 10) : null;
      var live = price !== null && retailIn && weeklyIn;
      var retail = live ? Math.round(parseFloat(retailIn.value) * 100) : 0;
      var weekly = live ? parseInt(weeklyIn.value, 10) || 1 : 1;
      var cover = live ? Math.min(n, Math.ceil(price / retail)) : -1;
      packs.forEach(function (b) {
        var on = b === cur;
        b.classList.toggle('is-on', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      if (rack) {
        var per = n % 6 === 0 ? 6 : 4, html = '';
        for (var i = 0; i < n; i += per) {
          html += '<div class="kcp-rack__row">';
          for (var k = i; k < Math.min(n, i + per); k++) html += bottle(live ? (k < cover ? 'is-cover' : 'is-margin') : '');
          html += '</div>';
        }
        rack.innerHTML = html;
      }
      if (!live) return;
      var unit = price / n, keep = retail - unit, value = retail * n, weeks = n / weekly;
      var cap = root.querySelector('[data-kcp-rack-cap]');
      if (cap) cap.innerHTML = '<b>' + cover + ' of ' + n + '</b> ' + nouns + ' cover the pack. <b>' + (n - cover) + '</b> are yours to keep.';
      text('[data-kcp-out-retail]', money(retail, fmt));
      text('[data-kcp-out-weekly]', weekly);
      text('[data-kcp-keep]', money(Math.round(keep), fmt));
      text('[data-kcp-keep-label]', 'kept per ' + noun + ' · ' + Math.round(keep / retail * 100) + '% margin');
      text('[data-kcp-m-cost]', money(price, fmt));
      text('[data-kcp-m-value]', money(value, fmt));
      text('[data-kcp-m-pack]', money(value - price, fmt));
      text('[data-kcp-m-cover]', cover + ' of ' + n);
      text('[data-kcp-m-weeks]', weeks >= 1 ? weeks.toFixed(1) : '<1');
      text('[data-kcp-m-month]', money(Math.round(keep * weekly * 4.33 / 100) * 100, fmt, true));
      if (addBtn) {
        addBtn.textContent = root.getAttribute('data-add-prefix') + ' ' + n + '-pack · ' + money(price, fmt);
        addBtn.disabled = cur.hasAttribute('data-unavailable');
      }
    }

    if (retailIn) retailIn.addEventListener('input', calc);
    if (weeklyIn) weeklyIn.addEventListener('input', calc);
    packs.forEach(function (b) {
      b.addEventListener('click', function () {
        cur = b;
        calc();
        document.dispatchEvent(new CustomEvent('kcpdp:select', { detail: { variantId: b.getAttribute('data-kcp-math-pack'), scroll: false } }));
      });
    });
    if (addBtn) addBtn.addEventListener('click', function () {
      var id = cur.getAttribute('data-kcp-math-pack');
      if (document.querySelector('[data-kcp-buybox]')) {
        document.dispatchEvent(new CustomEvent('kcpdp:select', { detail: { variantId: id, scroll: false } }));
        document.dispatchEvent(new CustomEvent('kcpdp:add', { detail: { variantId: id, quantity: 1 } }));
      } else {
        window.location.href = (root.getAttribute('data-cart-add') || '/cart/add') + '?id=' + encodeURIComponent(id) + '&quantity=1';
      }
    });
    root.kcpSync = function (id) {
      packs.forEach(function (b) { if (String(b.getAttribute('data-kcp-math-pack')) === String(id)) cur = b; });
      calc();
    };
    if (window.KCPDP && window.KCPDP.current) root.kcpSync(window.KCPDP.current.id); else calc();
  }

  document.addEventListener('kcpdp:variant', function (e) {
    if (!e.detail) return;
    Array.prototype.forEach.call(document.querySelectorAll('[data-kcp-math]'), function (root) { if (root.kcpSync) root.kcpSync(e.detail.id); });
  });
  function boot() { Array.prototype.forEach.call(document.querySelectorAll('[data-kcp-math]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kc-retail-room-shelf"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';
  function boot() {
    var hasCompanion = !!document.querySelector('[data-kcp-buybox] [data-kcp-option][data-group="companion"]');
    Array.prototype.forEach.call(document.querySelectorAll('[data-kcp-room-add]'), function (btn) {
      btn.hidden = !hasCompanion;
      if (btn.kcpReady) return;
      btn.kcpReady = true;
      btn.addEventListener('click', function () {
        document.dispatchEvent(new CustomEvent('kcpdp:select', { detail: { group: 'companion', scroll: true } }));
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  
  
  
  
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }
  customElements.define('cart-note', CartNote);





  } catch(e) { console.error(e); }
})();
})();
